module.exports = __webpack_public_path__ + "img/cat_big.2eac252c.jpg";